import { useAtom } from 'jotai';
import { useCallback } from 'react';
import { AccountResource } from '../../resources/account.resource.js';
import { balanceForCurrencyAtom } from '../../state/orders/balanceForCurrency.js';
import { Loadable, LoadableState } from '../../utils/useLoadableState.js';
import { GetResourceHeaderWithTokenForAccount } from '../useResource.js';

type UseOrderExchangeBalanceForCurrencyOutput = {
  balanceForCurrency: LoadableState<number | undefined>;
  loadBalanceForCurrency: (currency: string, accountId: string, mic: string) => Promise<void>;
};

export type UseOrderExchangeBalanceForCurrencyCommonPlatformParams = {
  accountResource: AccountResource;
  getResourceHeaderWithTokenForAccount: GetResourceHeaderWithTokenForAccount;
};

export const useOrderExchangeBalanceForCurrencyCommon = ({
  accountResource,
  getResourceHeaderWithTokenForAccount,
}: UseOrderExchangeBalanceForCurrencyCommonPlatformParams): UseOrderExchangeBalanceForCurrencyOutput => {
  const [balanceForCurrency, setBalanceForCurrency] = useAtom(balanceForCurrencyAtom);

  const loadBalanceForCurrency = useCallback(
    async (currency: string, accountId: string, mic: string): Promise<void> => {
      setBalanceForCurrency(Loadable.loading);
      try {
        const { data } = await accountResource.getCurrencyBalanceForOrder(
          { mic, sourceCcyCode: currency },
          getResourceHeaderWithTokenForAccount(accountId),
        );
        setBalanceForCurrency(Loadable.loaded(data.investableAmount));
      } catch (err) {
        setBalanceForCurrency(Loadable.failed);
      }
    },
    [accountResource, getResourceHeaderWithTokenForAccount, setBalanceForCurrency],
  );

  return { loadBalanceForCurrency, balanceForCurrency };
};
